var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.8098,
    cy: 24.5,
    rx: 24.6922,
    ry: 24.5,
    fill: "#CED4DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3139 25C28.9323 25 31.8648 22.0902 31.8648 18.5C31.8648 14.9098 28.9323 12 25.3139 12C21.6955 12 18.7629 14.9098 18.7629 18.5C18.7629 22.0902 21.6955 25 25.3139 25ZM30.2169 26.6555L27.7705 36.375L26.1327 29.4688L27.7705 26.625H22.8572L24.495 29.4688L22.8572 36.375L20.4109 26.6555C16.7618 26.8281 13.8496 29.7887 13.8496 33.45V35.5625C13.8496 36.9082 14.95 38 16.3063 38H34.3215C35.6777 38 36.7781 36.9082 36.7781 35.5625V33.45C36.7781 29.7887 33.866 26.8281 30.2169 26.6555V26.6555Z",
    fill: "#858585"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgUpload);
export default __webpack_public_path__ + "static/media/img-upload.bdd844677746aa8eff08012ef8ffe9b6.svg";
export { ForwardRef as ReactComponent };